import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Linkedin, Instagram } from 'lucide-react';
import { siteConfig } from '../data';

const Footer = () => {
  return (
    <footer className="bg-emerald-950 text-white border-t border-emerald-900/30">
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center mb-6">
              <img src={siteConfig.logo} alt={siteConfig.name} className="h-12 w-auto object-contain" />
            </Link>
            <p className="text-emerald-50/60 text-sm leading-relaxed">
              Professionel coaching og trivselsforløb til både private og virksomheder. 
              Vi skaber forandring gennem ansvar og mental balance.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">Hurtige links</h3>
            <ul className="space-y-4 text-sm">
              <li><Link to="/om" className="hover:text-emerald-300 transition-colors">Om coachen</Link></li>
              <li><Link to="/coaching" className="hover:text-emerald-300 transition-colors">1:1 Coaching</Link></li>
              <li><Link to="/foredrag" className="hover:text-emerald-300 transition-colors">Foredrag</Link></li>
              <li><Link to="/workshops" className="hover:text-emerald-300 transition-colors">Workshops</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">Ydelser &amp; Oplæg</h3>
            <ul className="space-y-4 text-sm">
              <li><Link to="/skaermen-hjernen-og-trivslen" className="text-emerald-300 font-medium hover:text-white transition-colors">Skærmen, hjernen og trivslen</Link></li>
              <li><Link to="/trivlogi-1-1" className="hover:text-emerald-300 transition-colors">1:1 Trivlogi® Forløb</Link></li>
              <li><Link to="/trivsel-i-faellesskabet" className="hover:text-emerald-300 transition-colors">Trivsel i fællesskabet</Link></li>
              <li><Link to="/trivsel-i-faellesskabet#konflikter" className="text-emerald-100/70 hover:text-emerald-300 transition-colors pl-2">↳ Konflikthåndtering</Link></li>
              <li><Link to="/trivsel-i-faellesskabet#ledelse" className="text-emerald-100/70 hover:text-emerald-300 transition-colors pl-2">↳ Ledelsesudvikling</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-6">Kontakt</h3>
            <ul className="space-y-4 text-sm mb-6">
              <li className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-white" />
                <span>{siteConfig.email}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-white" />
                <a href={`tel:${siteConfig.phone.replace(/\s/g, '')}`} className="hover:text-emerald-300 transition-colors">
                  {siteConfig.phone}
                </a>
              </li>
            </ul>
            <div className="flex items-center space-x-3">
              {siteConfig.social.facebook && (
                <a 
                  href={siteConfig.social.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-emerald-900/50 hover:bg-emerald-800 p-2 text-emerald-100 hover:text-white transition-all rounded-sm"
                  aria-label="Facebook"
                >
                  <Facebook className="h-5 w-5" />
                </a>
              )}
              {siteConfig.social.linkedin && (
                <a 
                  href={siteConfig.social.linkedin} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-emerald-900/50 hover:bg-emerald-800 p-2 text-emerald-100 hover:text-white transition-all rounded-sm"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="h-5 w-5" />
                </a>
              )}
              {siteConfig.social.instagram && (
                <a 
                  href={siteConfig.social.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-emerald-900/50 hover:bg-emerald-800 p-2 text-emerald-100 hover:text-white transition-all rounded-sm"
                  aria-label="Instagram"
                >
                  <Instagram className="h-5 w-5" />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-emerald-900/30 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-emerald-50/40">
          <div className="order-2 md:order-1">
            <a 
              href="https://auxo.dk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-semibold tracking-widest text-[10px] uppercase opacity-50 hover:opacity-100 transition-opacity cursor-pointer"
            >
              Developed by Auxo
            </a>
          </div>
          <div className="order-1 md:order-2">
            <p>&copy; {new Date().getFullYear()} {siteConfig.name}. Alle rettigheder forbeholdes.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
